export class IdsModel {
  ids: number[];
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/graph/ids.model.ts